import React from "react";
import Tippy from "@tippyjs/react";
import { EyeIcon, PencilIcon, TrashIcon } from "../Common/Icons";

import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import view from "../../images/view.png";
import editIcon from "../../images/icons/edit.png";

const ActionMenuItem = ({ data, context }) => {
  return (
    <>
      <Tippy content="View" trigger="mouseenter">
        <img
          id="isView"
          onClick={(e) => {
            context.onClickActionItemClick(data, e);
            console.log(e);
          }}
          src={view}
          className="img-fluid me-2"
          alt=""
        />
      </Tippy>

      {context.editAccess.map((e, i) => {
        return (
          <React.Fragment key={"at_" + i}>
            {e === context.userRole.userRole && data.is_active === true && (
              <Tippy content="Edit" trigger="mouseenter">
                <Link
                  id="isEdit"
                  onClick={(e) => context.onClickActionItemClick(data, e)}
                >
                  <img src={editIcon} className="img-fluid me-2" alt="" />
                </Link>
              </Tippy>
            )}
          </React.Fragment>
        );
      })}
      {/* {context.deleteAccess.map((e, i) => {
        return (
          <React.Fragment key={"at_" + i}>
            {e === context.userRole.userRole && data.is_active === true && (
              <Button
                type="button"
                variant="none px-2"
                id="isDelete"
                onClick={(e) => context.onClickActionItemClick(data, e)}
              >
                <TrashIcon size="24" color="#7f8192" />
              </Button>
            )}
          </React.Fragment>
        );
      })} */}
    </>
  );
};
export default ActionMenuItem;
